import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'sku-duplicate-category-modal--title',
    defaultMessage: 'Duplicate category',
  },
  categoryNameLabel: {
    id: 'sku-duplicate-category-modal--category-name-label',
    defaultMessage: 'Category name',
  },
  categoryNamePlaceholder: {
    id: 'sku-duplicate-category-modal--category-name-placeholder',
    defaultMessage: 'E.g. "Salads"',
  },
  selectMenu: {
    id: 'sku-duplicate-category-modal--select-menu',
    defaultMessage: 'Select menu',
  },
  itemsLabel: {
    id: 'sku-duplicate-category-modal--items-label',
    defaultMessage: 'Items',
  },
  removeItemAriaLabel: {
    id: 'sku-duplicate-category-modal--remove-item-aria-label',
    defaultMessage: 'Remove {itemName}',
  },
  closeAriaLabel: {
    id: 'sku-duplicate-category-modal--close-aria-label',
    defaultMessage: 'Close',
  },
  required: {
    id: 'sku-duplicate-category-modal--required',
    defaultMessage: 'Required',
  },
  cancel: {
    id: 'sku-duplicate-category-modal--cancel',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'sku-duplicate-category-modal--save',
    defaultMessage: 'Save',
  },
  copySuffix: {
    id: 'sku-duplicate-category-modal--copy-suffix',
    defaultMessage: '{categoryName} (Copy)',
  },
  categoryNameRequired: {
    id: 'sku-duplicate-category-modal--category-name-required',
    defaultMessage: 'Category name is required.',
  },
  categoryDuplicated: {
    id: 'sku-duplicate-category-modal--category-duplicated',
    defaultMessage: '<strong>{categoryName}</strong> category was successfully duplicated',
  },
  categoryDuplicatedWithLinkErrors: {
    id: 'sku-duplicate-category-modal--category-duplicated-with-link-errors',
    defaultMessage:
      '<strong>{categoryName}</strong> was duplicated, but {failedCount, plural, one {# item} other {# items}} could not be added',
  },
  categoryDuplicateError: {
    id: 'sku-duplicate-category-modal--category-duplicate-error',
    defaultMessage: '<strong>We were unable to duplicate your category</strong>',
  },
  categoryDuplicateErrorDescription: {
    id: 'sku-duplicate-category-modal--category-duplicate-error-description',
    defaultMessage:
      'Please check your connection and try again. If this problem continues, please <contact-us-link>contact us</contact-us-link>.',
  },
});
